module.exports = __webpack_public_path__ + "img/wechat@2x.fd29d70e.png";